<template>
    <section class='pwd-keyboard'>
        <w-row class="pwd-desc">
            <w-cell  align="center">请输入6位交易密码</w-cell>
        </w-row>
        <w-row class="pwd-input-box" align="center" style="justify-content: center" :height="50">
            <w-cell :width="300" class="input-box-wrapper wui-border-1px">
                <w-cell class="input-box" v-for="i in 6" :key="i" :width="50" align="center" :class="{'inputed':inputed && inputed[i-1]>=0}"></w-cell>
            </w-cell>
        </w-row>
        <w-row class="forgot-pwd" align="right"  style="justify-content: flex-end">
            <w-cell :width="80"><span class="forgot-pwd__button" @click="forgotPassword">忘记密码?</span></w-cell>
        </w-row>
        <div class="keyboard-wrapper">
            <number-keyboard @input="handleInput"></number-keyboard>
        </div>
        
    </section>
</template>
<script>
    import numberKeyboard from './number-keyboard';
    export default {
        components: {
            numberKeyboard
        },
        props: {
            pwd: Array,
            leftText: String,
            rightText: String
        },
        data() {
            return {
                inputed: this.pwd
            }
        },
        watch: {
            'pwd' (newValue) {
                if (Array.isArray(newValue) && newValue.length === 0) {
                    this.inputed = newValue;
                }
            }
        },
        methods: {
            handleInput(value) {
                if (value === "delete") {
                    this.inputed.length > 0 && this.inputed.pop();
                } else if (value >= 0 && value <= 9) {
                    this.inputed.length < 6 && this.inputed.push(value);
                }
                if (this.inputed.length === 6) {
                    this._completeInput();
                }
            },
            forgotPassword() {
                this.$emit("hidden");
                this.$wui.Dialog.show({
                    content: '请登录万达财富App后重置交易密码',
                    buttons: [{
                        text: '暂不重置'
                    }, {
                        text: '去重置',
                        action: () => console.log('去重置')
                    }]
                });
            },
            handleHidden() {
                this.$emit("hidden");
            },
            _completeInput() {
                let pwd = this.inputed.join('');
                this.$emit("complete", pwd);
            }
        }
    }
</script>
<style lang='sass' scoped>
    $mfontSize:14px;
    $fontColor:#666666;
    $mainColor:#478df5;

    .pwd-keyboard {
        height: 100%;
        position: relative;
        .keyboard-wrapper{
            position: absolute;
            bottom:0;
            left:0;
            right:0;
        }
    }
    
    .custom-area {
        padding: 10px;
        position: relative;
        font-size: $mfontSize;
    }
    
    .custom-area__action-content {
        padding-left: 5px;
    }
    
    .pwd-desc {
        height: 50px;
        font-size: $mfontSize;
        color: $fontColor;
        line-height: $mfontSize;
    }
    
    .pwd-input-box {}
    
    .input-box-wrapper {
        height: 50px;
        position: relative;
    }
    
    .forgot-pwd {
        padding: 18px;
    }
    
    .forgot-pwd__button {
        font-size: $mfontSize;
        color: $mainColor;
        line-height: $mfontSize;
    }
    
    .input-box {
        height: 100%;
        position: relative;
    }
    
    .input-box.inputed {
        &:before {
            content: '';
            width: 14px;
            height: 14px;
            border-radius: 7px;
            background-color: #478df5;
        }
    }
</style>


// WEBPACK FOOTER //
// pwd-keyboard.vue?e748b758